var map = {
	"./de/NVIDIA.png": "vDTC",
	"./en/NVIDIA.png": "yr1K",
	"./es/NVIDIA.png": "Mmva",
	"./fr/NVIDIA.png": "V9jl",
	"./ja/NVIDIA.png": "qKZM",
	"./ko/NVIDIA.png": "iZwS",
	"./pt/NVIDIA.png": "BzDi",
	"./ru/NVIDIA.png": "INg/",
	"./tc/NVIDIA.png": "FzZn",
	"./th/NVIDIA.png": "C4mf",
	"./zh-Hant/NVIDIA.png": "P82f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iG6R";